import TemplateManager from './template-manager';

const MAX_UNFOLDED = 7;

class OffersPaginator {

    constructor() {
        this._container = document.querySelector('[data-contains="search-results:pagination"]');

        if(!this._container)
        {
            return;
        }

        $(document).on('offers-pagination:fill', (event, payload) => {
            try {
                return this._fill(payload);
            } catch(e) { console.error(e); }
        });

        $(document).on('offers-pagination:reset', (event, payload) => {
            try {
                return this._reset();
            } catch(e) { console.error(e) }
        });

        $(document).on('click', '[data-contains="search-results:paginator-link"]', (event) => {
            event.preventDefault();
            this._selectPage(event);
        });
    }

    _reset() {
        $(document).trigger('offers-search:push-to-payload', {page: 1}).trigger('url-manager:remove', ['page']);
    }

    _fill({page = 1, total = 1}) {
        while( this._container.firstChild )
        {
            this._container.firstChild.remove();
        }

        if(total <= 1)
        {
            return;
        }

        page = parseInt(page);

        if( ! Number.isNaN(page) && total > MAX_UNFOLDED)
        {
            return this._buildFoldedPagination({page, total});
        }

        for(let i = 1; i <= total; i++)
        {
            this._buildSnippet(i, page);
        }
    }

    _buildFoldedPagination({page, total})
    {
        this._buildSnippet(1, page);

        if( page <= (MAX_UNFOLDED - 3) )
        {
            //lower fold; for 14 pages looks like [1,2,3,4,5,...,14]
            for(let i = 2; i <= (MAX_UNFOLDED - 2); i++)
            {
                this._buildSnippet(i, page);
            }

            this._buildSnippet(false, page);
        }
        else if( page >= (total - 3) )
        {
            //upper fold; for 14 pages looks like [1,...,10,11,12,13,14]

            this._buildSnippet(false, page);

            for(let i = (total - 4); i < total; i++)
            {
                this._buildSnippet(i, page);
            }

        }
        else
        {
            // middle folds

            this._buildSnippet(false, page);

            for(let i = (page - 1); i <= (page + 1); i++)
            {
                this._buildSnippet(i, page);
            }

            this._buildSnippet(false, page);
        }

        this._buildSnippet(total, page);
    }

    _buildSnippet(pageNo, currentPage) {
        let snippet = TemplateManager.get('search-results--pagination-link').querySelector('[data-contains="search-results:paginator-link"]');

        if(!snippet)
        {
            return;
        }

        if( typeof pageNo === 'number' && Number.isInteger(pageNo) )
        {
            snippet.setAttribute('data-page-no', pageNo);
            snippet.innerText = pageNo;
            snippet.setAttribute('href', window.location.origin + window.location.pathname + window.buildHref(pageNo === 1 ? {} : {page: pageNo}));

            if( pageNo === currentPage )
            {
                snippet.classList.add('active');
            }
        }
        else
        {
            snippet.innerText = '...';
            snippet.setAttribute('href', 'javascript:;');
            snippet.setAttribute('disabled', true);
            snippet.classList.add('disabled');
            snippet.removeAttribute('data-page-no');
            snippet.removeAttribute('data-contains');
        }

        this._container.appendChild(snippet);
    }

    _selectPage(event) {
        let page;

        try {
            page = parseInt( event.target.getAttribute('data-page-no') );

            ( typeof page !== 'number' || ! Number.isInteger(page) || page <= 1 )
                ? $(document).trigger('url-manager:remove', ['page'])
                : $(document).trigger('url-manager:push', [{page}]);
        } catch(e) {
            page = 1;

            $(document).trigger('url-manager:remove', ['page']);
        }

        window.fetchSearchResults({page}, true);
    }


}

try {
    (function($) {
        new OffersPaginator($);
    })(window.jQuery);
} catch( e ) { console.log(e); }